<template>
  <section :class="`${sectionName} draft-order-confirm-page-section`">
    <div
      :class="`${sectionName}__container draft-order-confirm-page-section__container`"
    >
      <div
        :class="`${sectionName}__head  draft-order-confirm-page-section__head`"
      >
        <h2
          :class="`${sectionName}__title  draft-order-confirm-page-section__title`"
        >
          {{ title }}
        </h2>
      </div>
      <div
        :class="`${sectionName}__value  draft-order-confirm-page-section__value`"
      >
        <slot />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    sectionName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.draft-order-confirm-page-section {
  max-width: 375px;
  margin: 0 auto;

  &__title {
    @extend %caption-bold;
    padding: 16px;
  }

  &__value {
    @extend %caption-black;
    padding: 0 16px;
  }
}
</style>
